// extracted by mini-css-extract-plugin
module.exports = {"label":"_93444fe79c--label--1VdtZ","xs":"_93444fe79c--xs--3X2cb","warning":"_93444fe79c--warning--1isE9","success":"_93444fe79c--success--39_XW"};